import { useSelector } from 'react-redux';
import { ContentFrame, ScreenContainer } from '@pinwheel/origami';
import React from 'react';
import { useOpts } from '../../context';
import { useDDFormContext } from '../../hooks/useDDFormContext';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import { selectCurrentSource, selectLastSource, } from '../../state/slices/slice-segment';
import ModalHeader from '../../components/ModalHeader';
import { EventAction, EventType } from '../../types/events';
import TitleFrame from '../../LinkApiRouter/components/TitleFrame';
import useBankInfoInputSubtitle from '../../LinkApiRouter/hooks/useBankInfoInputSubtitle';
import { BankInfoInputInner } from '../BankInfoInput';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
var DDFormBankInfoInput = function () {
    var opts = useOpts();
    var goBack = useDDFormContext().goBack;
    var navigate = useLinkNavigate();
    var currentSource = useSelector(selectCurrentSource);
    var lastSource = useSelector(selectLastSource);
    var subtitle = useBankInfoInputSubtitle();
    var getLocalizedString = useGetLocalizedString();
    var handleContinue = function () {
        opts.fireUnifiedEvent(EventType.LINK_DIRECT_DEPOSIT_FORMS_EVENT, {
            action: EventAction.CONTINUE,
            entry_point: lastSource,
            source: currentSource,
        });
        navigate('/dd-form/confirmation-screen');
    };
    return (React.createElement(ScreenContainer, null,
        React.createElement(ModalHeader, { onBack: goBack, "data-testid": "DDFormBankInfoInput" }),
        React.createElement(ContentFrame, null,
            React.createElement(TitleFrame, { title: getLocalizedString('CONFIRM_ACCOUNT_DETAILS'), subtitle: subtitle, "data-testid": "DDFormBankInfoInput" },
                React.createElement(BankInfoInputInner, { onContinue: function () { return handleContinue(); } })))));
};
export default DDFormBankInfoInput;
